import React, { useContext } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";

import Home from "./Admin/Home";
import VerifyUser from "./Admin/VerifyUser";
import "./App.css";
import Dashboard3 from "./BrandOnBoarding/Dashboard/Dashboard";
import HomePage from "./BrandOnBoarding/HomePage/HomePage";
import SettingsList from "./BrandOnBoarding/Settings/SettingsList";
import BrandReport from "./BrandReport";
import AuthComponent from "./Component/AuthComponent/AuthComponent";
import AddReport from "./Component/BasicCardComponent/Reporting/AddReport";
import ComparisonReportingComponent from "./Component/BasicCardComponent/Reporting/ComparisonReportingComponent";
import Reporting from "./Component/BasicCardComponent/Reporting/Reporting";
import Dashboard from "./Component/Dashboard/Dashboard";
import LlmUsageRecordComponent from "./Component/LlmUsageRecord/LlmUsageRecordComponent";
import MonitorSetup from "./Component/MonitoringComponent/MonitorSetup";
import MonitoringReport from "./Component/MonitoringComponent/MonitoringReport";
import PromptCreationComponent from "./Component/PromptCreationComponent/PromptCreationComponent";
import Dashboard2 from "./Component/devDashboard2/Dashboard2";
import AdminLayout from "./Layout/AdminLayout";
import { AuthContext } from "./context/auth-context";
import Actions from "./luminaire/Actions/Actions";
import BrandAudit from "./luminaire/BrandAudit/BrandAudit";
import CategoryAnalysis from "./luminaire/CategoryAnalysis/CategoryAnalysis";
import CategoryMonitoring from "./luminaire/CategoryMonitoring/CategoryMonitoring";
import BuyingJourney from "./luminaire/BuyingJourney/BuyingJourney";
import CategoryDiscovery from "./luminaire/CategoryDiscovery/CategoryDiscovery";
import ContentLayout from "./luminaire/ContentLayout";
import LuminaireDashboard from "./luminaire/Dashboard/Dashboard";
import DiscoveryV2 from "./luminaire/DiscoveryV2/Discovery";
import Discovery from "./luminaire/Discovery/Discovery";
import LuminaireHome from "./luminaire/HomePage/HomePage";
import HomePageNew from "./luminaire/HomePageNew/HomePageNew";
import ChatAssistant from "./Component/ChatAssistant/ChatAssistant";
import LLMReporting from "./luminaire/LLMReporting/LLMReporting";
import MetricContentMapping from "./luminaire/MetricContentV2/MetricContent";
import PromptEngine from "./luminaire/PromptEngine/PromptEngine";
import Settings from "./luminaire/Settings/Settings";
import { newVersionAvailableToRefresh } from "./services/apiService";
import PurchaseFunnel from "./luminaire/PurchaseFunnel/PurchaseFunnel";
import Conversations from "./luminaire/Conversations/Conversations";
import ConversationsV2 from "./luminaire/Conversations/ConversationsV2";
import ConversationsV3 from "./luminaire/Conversations/V3/ConversationsV3";
import userMetricSettingCreation from "./luminaire/Set/userMetricSettingCreation";

function App() {
  const { token, user, isCurrentUserAdmin } = useContext(AuthContext);
  const isChatBotEnabled = user?.is_chat_bot_enable === true;
  // const { is_chat_bot_enable } = user;
  // console.log("User in App.js:", user);
  const navigate = useNavigate();
  const location = useLocation();
  const isReporting = new URLSearchParams(window.location.search).get('isReporting') === 'true' || new URLSearchParams(window.location.search).get('reporting') === 'true';

  React.useEffect(() => {
    const interval = setInterval(async () => {
      const token = localStorage.getItem("token");
      if (token) {
        const isNewVersionAvailable = await newVersionAvailableToRefresh();
        if (isNewVersionAvailable) {
          setTimeout(() => {
            window.location.reload(true);
          }, 3000);
        }


      }
    }, 60000);

    const interval6Sec = setInterval(() => {
      if (token && location.pathname === "/luminaire/discovery") {
        navigate("/luminaire/discoveryV2", { replace: true });
      }
    }, 6000);

    return () => {
      clearInterval(interval6Sec);
      clearInterval(interval);
    };
  }, []);


  const renderProtectedElement = (Component, props = {}) => {
    return token && user && user?.is_verified ? (
      <Component {...props} />
    ) : (
      <Navigate to="/login" />
    );
  };

  console.log('test==disoverypath>', user?.is_discoveryOld_disabled)

  const getDiscoveryPath = () =>
    user?.is_discoveryOld_disabled ? "/luminaire/discoveryV2" : "/luminaire/discovery";

  const renderAdminElement = (Component) => {
    return isCurrentUserAdmin ? (
      <Component />
    ) : token ? (
      <Navigate to="/luminaire/discoveryV2" />
    ) : (
      <Navigate to="/login" />
    );
  };

  const renderLoginElement = (Component) => {
    return token && user && user?.is_verified ? (
      <Navigate to="/luminaire/discoveryV2" />
    ) : (
      <Component />
    );
  };

  return (
    <div className="App">
      <Routes>
        {/* <Route
            path="/:focusingArea?"
            element={renderProtectedElement(MainPage)}
          /> */}
        <Route
          path="/"
          element={<Navigate to="/luminaire/discoveryV2" replace />}
        />
        <Route path="/add-report" element={renderProtectedElement(AddReport)} />
        <Route path="/brand-report" element={<BrandReport />} />
        <Route
          path="/llmreportdata"
          element={renderProtectedElement(ComparisonReportingComponent)}
        />
        <Route path="/reporting" element={renderProtectedElement(Reporting)} />
        <Route
          path="/monitors"
          element={renderProtectedElement(MonitorSetup)}
        />
        <Route
          path="/monitoringreport/:id"
          element={renderProtectedElement(MonitoringReport)}
        />
        <Route path="/dashboard" element={renderProtectedElement(Dashboard)} />
        <Route
          path="/dashboard2"
          element={renderProtectedElement(Dashboard2)}
        />
        <Route
          path="/brandonboarding/dashboard"
          element={renderProtectedElement(Dashboard3)}
        />
        <Route
          path="/monitors"
          element={renderProtectedElement(MonitorSetup)}
        />
        <Route
          path="/llmusagerecord"
          element={renderProtectedElement(LlmUsageRecordComponent)}
        />
        <Route
          path="/brandonboarding/settings"
          element={renderProtectedElement(SettingsList)}
        />
        <Route
          path="/brandonboarding/home"
          element={renderProtectedElement(HomePage)}
        />
        <Route
          path="/brandonboarding"
          element={renderProtectedElement(HomePage)}
        />
        <Route
          path="/monitoringreport/:id"
          element={renderProtectedElement(MonitoringReport)}
        />
        <Route
          path="/admin"
          element={renderAdminElement(PromptCreationComponent)}
        />

        <Route path="/luminaire" element={<ContentLayout />}>
          <Route index element={renderProtectedElement(Discovery)} />
          <Route path="home" element={renderProtectedElement(LuminaireHome)} />
          <Route path="home-page-new" element={renderProtectedElement(HomePageNew)} />
          <Route
            path="brand-monitoring"
            element={renderProtectedElement(
              () => (
                <>
                  <LuminaireDashboard />
                  {!isReporting && isChatBotEnabled &&  <ChatAssistant />}
                </>
              ),
              { key: "brand-monitoring" }
            )}
          />

          <Route
            path="product-monitoring"
            element={renderProtectedElement(LuminaireDashboard, {
              key: "product-monitoring",
            })}
          />
          <Route path="actions" element={renderProtectedElement(Actions)} />
          {/* <Route
            path="discovery"
            element={renderProtectedElement(Discovery)}
          /> */}
          <Route
            path="discoveryV2"
            element={renderProtectedElement(DiscoveryV2)}
          />

          <Route
            path="conversations"
            element={renderProtectedElement(ConversationsV2)}
          />
          <Route
            path="conversations/:id"
            element={renderProtectedElement(ConversationsV2)}
          />

          {/* V3 — isolated full copy of ConversationsV2, Monitoring tab reworked
              to browse Discovery history instead of the customer-monitoring-filters API */}
          <Route
            path="conversations-v3"
            element={renderProtectedElement(ConversationsV3)}
          />
          <Route
            path="conversations-v3/:id"
            element={renderProtectedElement(ConversationsV3)}
          />

          <Route
            path="buying-journey"
            element={renderProtectedElement(BuyingJourney)}
          />
          <Route
            path="metric-content"
            element={renderProtectedElement(MetricContentMapping)}
          />
          <Route
            path="metric-content/:id"
            element={renderProtectedElement(MetricContentMapping)}
          />
          <Route
            path="brand-audit"
            element={renderProtectedElement(BrandAudit)}
          />
          <Route
            path="category-analysis"
            element={renderProtectedElement(CategoryAnalysis)}
          />
          <Route
            path="category-monitoring"
            element={renderProtectedElement(CategoryMonitoring)}
          />
          <Route
            path="prompt-engine"
            element={renderProtectedElement(PromptEngine)}
          />
          <Route
            path="purchase-funnel"
            element={renderProtectedElement(PurchaseFunnel)}
          />
          {/* <Route
              path="category-discovery"
              element={renderProtectedElement(CategoryDiscovery)}
            /> */}
          <Route
            path="llm-reporting"
            element={renderProtectedElement(LLMReporting)}
          />
          {(user?.user_role?.role?.name == "Company admin" ||
            user?.user_role?.role?.name == "Super User") && (
            <Route path="settings" element={renderProtectedElement(Settings)} />
          )}
          <Route
            path="templateSetting"
            element={renderProtectedElement(userMetricSettingCreation)}
          />
        </Route>

        <Route path="/login" element={renderLoginElement(AuthComponent)} />
        <Route path="/verify-user" element={<VerifyUser />} />
        {user?.user_role?.role_id === 1 && (
          <Route path="/system" element={<AdminLayout />}>
            <Route path="" element={<Home />} />
          </Route>
        )}
        <Route
          path="*"
          element={<Navigate to="/luminaire/discoveryV2" replace />}
        />
      </Routes>
            {/* {token && user && user?.is_verified && <ChatAssistant />} */}
    </div>
  );
}

export default App;
